import { ApiService } from '../services/data/api.service';
import { StorageService } from '../services/storage.service';
import { AuthService } from '../services/account/auth.service';
import { LayoutFactory } from '../data/layout/factory.layout';
/*    , , BaseCodeLookupService,
    OptionsSetupFactory, OptionsConstant, OptionsConstantValue
} from './';*/
import { Injectable } from '@angular/core';
import { AppSettingsService } from '../services/core/app-settings.service';

@Injectable()
export class MainDataFactory {
    constructor(public APIService: ApiService, public AuthService: AuthService, public LayoutFactory: LayoutFactory,
        //public StyleLayoutFactory: StyleLayoutFactory, public PageTitleFactory: PageTitleFactory, //public BaseCodeLookupService: BaseCodeLookupService,
        public StorageService: StorageService, //public OptionsSetupFactory: OptionsSetupFactory, public OptionsConstant: OptionsConstant,
        /*public OptionsConstantValue: OptionsConstantValue, */public appSettingsService: AppSettingsService) {       
    }
}